import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { HelperMessage } from '@atlaskit/form';
import { FormattedHTMLMessage } from 'react-intl';
import { HelpContainer } from './styled';
import { messages } from './messages';
import { useEditorViewHasFocus, useScopedId } from '../../../state';
import { JQL_EDITOR_HELP_CONTENT_ID } from '../../../common/constants';
import { useEditorViewIsInvalid } from '../../../hooks/use-editor-view-is-invalid';
import { useEditorThemeContext } from '../../../hooks/use-editor-theme';
export var JQLEditorHelp = function JQLEditorHelp() {
  var editorViewIsInvalid = useEditorViewIsInvalid();

  var _useEditorViewHasFocu = useEditorViewHasFocus(),
      _useEditorViewHasFocu2 = _slicedToArray(_useEditorViewHasFocu, 1),
      editorViewHasFocus = _useEditorViewHasFocu2[0];

  var _useEditorThemeContex = useEditorThemeContext(),
      isSearch = _useEditorThemeContex.isSearch;

  var _useScopedId = useScopedId(JQL_EDITOR_HELP_CONTENT_ID),
      _useScopedId2 = _slicedToArray(_useScopedId, 1),
      helpContentId = _useScopedId2[0];

  var SearchMessage = /*#__PURE__*/React.createElement(FormattedHTMLMessage, messages.searchCommand);
  var NewLineMessage = /*#__PURE__*/React.createElement(FormattedHTMLMessage, isSearch ? messages.newLineCommand : messages.fieldNewLineCommand); // Ensure help text remains visible if no error is message is being shown and editor view has focus

  var isVisible = !editorViewIsInvalid && editorViewHasFocus;
  return /*#__PURE__*/React.createElement(HelpContainer, {
    id: helpContentId,
    isVisible: isVisible
  }, isSearch && /*#__PURE__*/React.createElement(HelperMessage, null, SearchMessage), /*#__PURE__*/React.createElement(HelperMessage, null, NewLineMessage));
};